export const CAROUSEL_SERVICES_QA = [{
  id: 1309,
  iconName: 'website'
}, // website development
{
  id: 1308,
  iconName: 'customModules'
}, // website design
{
  id: 1292,
  iconName: 'integrations'
}, // custom api integrations
{
  id: 48553,
  iconName: 'reports'
}, // account based marketing
{
  id: 1301,
  iconName: 'salesQuote'
}, // paid advertising
{
  id: 1298,
  iconName: 'tag'
}, // full inbound marketing services
{
  id: 1288,
  iconName: 'edit'
}, // content creation
{
  id: 1305,
  iconName: 'workflows'
}, // sales enablement
{
  id: 1297,
  iconName: 'logEmail'
}, // email marketing
{
  id: 1304,
  iconName: 'cap'
}, // sales coaching and training
{
  id: 1293,
  iconName: 'contactDuplicate'
}, // customer marketing
{
  id: 1303,
  iconName: 'salesTemplates'
} // sales and marketing alignment
];
export const CAROUSEL_SERVICES_PROD = [{
  id: 24,
  iconName: 'website'
}, // website development
{
  id: 23,
  iconName: 'customModules'
}, // website design
{
  id: 7,
  iconName: 'integrations'
}, // custom api integrations
{
  id: 39001,
  iconName: 'reports'
}, // account based marketing
{
  id: 16,
  iconName: 'salesQuote'
}, // paid advertising
{
  id: 13,
  iconName: 'tag'
}, // full inbound marketing services
{
  id: 3,
  iconName: 'edit'
}, // content creation
{
  id: 20,
  iconName: 'workflows'
}, // sales enablement
{
  id: 12,
  iconName: 'logEmail'
}, // email marketing
{
  id: 19,
  iconName: 'cap'
}, // sales coaching and training
{
  id: 8,
  iconName: 'contactDuplicate'
}, // customer marketing
{
  id: 1,
  iconName: 'salesTemplates'
} // sales and marketing alignment
];
export const ACCREDITATION_CARDS_PROD = [{
  id: 43003,
  iconName: 'crm'
}, // CRM Implementation
{
  id: 52001,
  iconName: 'mobile-onboarding-account-ready'
}, // HubSpot Onboarding
{
  id: 43004,
  iconName: 'deals'
}, // Advanced CMS Implementation
{
  id: 78002,
  iconName: 'general-object-properties'
}, // Custom Integration
{
  id: 123,
  iconName: 'crm-migrations-bot'
}, // Data Migration | TODO: temporary id - update when live
{
  id: 63001,
  iconName: 'content-strategy'
}, // Platform Enablement
{
  id: 456,
  iconName: 'call-to-action'
} // Solutions Architecture | TODO: temporary id - update when live
];